import React, { useState, useEffect } from 'react';
import { api } from '../apiClient';
import { Coins, Plus } from 'lucide-react';

const CreditCounter = ({ onOpen }) => {
    const [credits, setCredits] = useState(null);

    const fetchCredits = async () => {
        try {
            const response = await api.get('/users/me/credits');
            setCredits(response.data.credits);
        } catch (error) {
            console.error("Failed to fetch credits:", error);
        }
    };

    useEffect(() => {
        fetchCredits();
        const interval = setInterval(fetchCredits, 30000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        const handleCreditUpdate = () => fetchCredits();
        window.addEventListener('credits-updated', handleCreditUpdate);
        return () => window.removeEventListener('credits-updated', handleCreditUpdate);
    }, []);

    if (credits === null) return null;

    return (
        <div className="flex items-center bg-primary rounded-full px-3 py-1 cursor-pointer hover:bg-primary/90 transition text-white" onClick={onOpen}>
            <Coins size={16} className="text-yellow-400 mr-2" />
            <span className="font-bold mr-2">{credits}</span>
            <div className="bg-white/20 rounded-full p-0.5">
                <Plus size={12} className="text-white" />
            </div>
        </div>
    );
};

export default CreditCounter;
